import { animate, state, style, transition, trigger, keyframes } from '@angular/animations';

export const BOUNCE_IN_UP =
	trigger('bounceInUp', [
		state('on', style({
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
		})),
		state('off',   style({
            transform: 'translate3d(0, 3000px, 0)',
            opacity: 0
		})),
	transition('on => off', animate('1s ease-out')),
      transition('off => on', animate('1s cubic-bezier(0.215, 0.610, 0.355, 1.000)', keyframes(
		[
			style({transform: 'translate3d(0, 3000px , 0)', offset: 0}),
			style({transform: 'translate3d(0, -50px, 0)', opacity: 1, offset: 0.6}),
			style({transform: 'translate3d(0, 20px, 0)', opacity: 1,  offset: 0.75}),
			style({transform: 'translate3d(0, -25px, 0)', opacity: 1,  offset: 0.90}),
			style({transform: 'translate3d(0, 0, 0)', opacity: 1,  offset: 1.0})
		]
	)))
    ]); 